import React, { memo, useMemo } from 'react';
import { Show, SimpleShowLayout } from 'react-admin';
import GridProfile from './GridProfile';

const Profile = (props) => {
  const userId = useMemo(() => {
    const user = localStorage.getItem('user');
    return JSON.parse(user).id.toString();
  }, []);

  return (
    <Show {...props} id={userId} resource="users">
      <SimpleShowLayout>
        <GridProfile />
      </SimpleShowLayout>
    </Show>
  );
};

export default memo(Profile);
